




import "./App.css";
import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import AnimatedRoutes from "./component/AnimatedRoutes";
import ScrollToTop from "./utils/ScrollToTopUtils";
import FullPageLoader from "./component/FullPageLoader";
import { LoaderProvider } from "./utils/LoaderUtils";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { useLocation } from "react-router-dom";





function App() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (window.location.search) {
      const queryObject = {};
      params.forEach((value, key) => {
        queryObject[key] = value;
      });
      localStorage.setItem("tracking_params", JSON.stringify(queryObject));
    }
  }, []);

  return (
    <LoaderProvider>
      <BrowserRouter>

        <ScrollToTop />

       <FullPageLoader/>
        <AnimatedRoutes />
        <ToastContainer position="top-right" autoClose={4000} theme="dark" />
      </BrowserRouter>
    </LoaderProvider>
  );
}

export default App;

// import logo from './logo.svg';
// import './App.css';
// import { BrowserRouter } from 'react-router-dom';
// import AnimatedRoutes from './component/AnimatedRoutes';
// import ScrollToTop from './utils/ScrollToTopUtils';
// import { LoaderProvider } from './utils/LoaderUtils';

// function App() {
//   return (
//     <>

//       <LoaderProvider>
//         <BrowserRouter>
//           <ScrollToTop />
//           <AnimatedRoutes />
//         </BrowserRouter>
//       </LoaderProvider>

//     </>
//   );
// }

// export default App;
